import type { MessageInitShape, MessageShape } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import {
  applyDemandGroupCsv,
  getDemandGroupDirectory,
  listDemandGroupMembers,
} from '@ebalance/proto/bffuser/v1/demand_group_service-DemandGroupService_connectquery'
import type {
  ApplyDemandGroupCsvRequestSchema,
  ApplyDemandGroupCsvResponseSchema,
} from '@ebalance/proto/bffuser/v1/demand_group_service_pb'
import { useQueryClient } from '@tanstack/react-query'
import type { UseMutationResult } from '@tanstack/react-query'

/**
 * 需要グループ CSV の Apply mutation hook (demand-groups-upload-tracer
 * AC-03/04/05/07)。有効な check_token を渡すと需要グループ + 所属供給地点が
 * DB に登録される。期限切れ / 他組織の token は NotFound (5) で拒否される
 * (AC-04/05, caller は Code.NotFound を「有効期限切れ」誘導に読み替える)。
 *
 * 取込が成功したら需要グループ画面の目録・所属の cache を無効化する (CSV 画面から
 * 戻った時に古い目録を見せない)。
 */
export function useApplyDemandGroupCsv(): UseMutationResult<
  MessageShape<typeof ApplyDemandGroupCsvResponseSchema>,
  ConnectError,
  MessageInitShape<typeof ApplyDemandGroupCsvRequestSchema>
> {
  const queryClient = useQueryClient()
  return useMutation(applyDemandGroupCsv, {
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: getDemandGroupDirectory,
          cardinality: 'finite',
        }),
      })
      void queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: listDemandGroupMembers,
          cardinality: 'finite',
        }),
      })
    },
  })
}
